export const extractVimeoData = url => {
    if (!url) return null;

    const cleaned = url.trim();

    // Extract videoId + hash
    // Matches:
    // - https://vimeo.com/800809710
    // - https://vimeo.com/800809710/6bebfb6829
    // - https://player.vimeo.com/video/800809710?h=6bebfb6829
    const idRegex = /vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-zA-Z0-9]+))?/;
    const idMatch = cleaned.match(idRegex);

    if (!idMatch) return null;

    const videoId = idMatch[1];
    const hash = idMatch[2] || null;

    // Default time values
    let startAt = null;
    let endAt = null;

    // Extract time fragment
    // Formats supported:
    // - #t=2s
    // - #t=2s,4s
    // - #t=2s&end=4s
    // - #t=120 (no "s")
    const fragment = cleaned.split('#')[1];
    if (fragment) {
        const params = new URLSearchParams(fragment);

        // "t" can contain "2s" or "2s,4s"
        if (params.has('t')) {
            const t = params.get('t');

            if (t.includes(',')) {
                // #t=2s,4s
                const [startStr, endStr] = t.split(',');
                startAt = parseInt(startStr);
                endAt = parseInt(endStr);
            } else {
                // #t=2s or #t=120
                startAt = parseInt(t);
            }
        }

        // Optional "end" parameter
        if (params.has('end')) {
            endAt = parseInt(params.get('end'));
        }
    }

    return {
        videoId,
        hash,
        startAt,
        endAt
    };
};

export const fetchVimeoMetadata = async (videoId, hash = null) => {
    // Build the correct URL
    const videoUrl = hash
        ? `https://vimeo.com/${videoId}/${hash}`
        : `https://vimeo.com/${videoId}`;

    const oembedUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`;

    const response = await fetch(oembedUrl);
    if (!response.ok) {
        throw new Error("Video not found or private");
    }

    return await response.json();
};
